export default __webpack_public_path__ + "static/media/result_breast_good.4a136173.jpg";